import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Animated construction materials floating */}
      <div className="absolute inset-0">
        {/* Steel beams animation */}
        <div className="absolute top-1/4 left-0 w-32 h-2 bg-gray-400 opacity-20 animate-float" 
             style={{ animationDelay: '0s', animationDuration: '8s' }}></div>
        <div className="absolute top-1/2 right-0 w-24 h-2 bg-gray-500 opacity-30 animate-float-reverse" 
             style={{ animationDelay: '2s', animationDuration: '10s' }}></div>
        <div className="absolute bottom-1/3 left-1/4 w-28 h-2 bg-gray-400 opacity-25 animate-float" 
             style={{ animationDelay: '4s', animationDuration: '9s' }}></div>
        
        {/* Concrete blocks */}
        <div className="absolute top-1/3 left-1/2 w-8 h-8 bg-gray-600 opacity-20 animate-bounce-slow" 
             style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 right-1/3 w-6 h-6 bg-gray-500 opacity-25 animate-bounce-slow" 
             style={{ animationDelay: '3s' }}></div>
        
        {/* Glass panels */}
        <div className="absolute top-2/3 left-1/3 w-16 h-20 bg-gradient-to-b from-blue-200 to-blue-300 opacity-10 animate-sway" 
             style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/5 right-1/4 w-12 h-16 bg-gradient-to-b from-blue-200 to-blue-300 opacity-15 animate-sway" 
             style={{ animationDelay: '5s' }}></div>
        
        {/* Supply chain connections */}
        <div className="absolute top-1/2 left-1/4 w-px h-32 bg-gradient-to-b from-transparent via-blue-400 to-transparent opacity-30 animate-pulse"></div>
        <div className="absolute top-1/3 right-1/2 w-32 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-30 animate-pulse" 
             style={{ animationDelay: '1.5s' }}></div>
        
        {/* Floating particles representing materials */}
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full opacity-20 animate-float-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 6}s`,
              animationDuration: `${4 + Math.random() * 4}s`
            }}
          ></div>
        ))}
      </div>
      
      {/* Company branding overlay */}
      <div className="absolute bottom-8 left-8 text-white/50 text-sm">
        <div className="mb-2">European Construction Materials</div>
        <div className="text-xs">Import • Export • Distribution • Logistics</div>
      </div>
    </div>
  );
};

export default AnimatedBackground;